module.exports = __webpack_public_path__ + "static/img/1-1.64a0056.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/1-1.png
// module id = lsyH
// module chunks = 0